import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/gallery/gallery-client.tsx");
